<template>
  <div>
    <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs"
      :form-fields="formFields" :permission="permission" />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'UniPromotionTask',
  components: { CommonTable },
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/],
      permission: {
        add: 'uniPromotionTask:add',
        update: 'uniPromotionTask:update',
        delete: 'uniPromotionTask:delete',
        deleteBatch: 'uniPromotionTask:deleteBatch'
      },
      url: {
        get: '/uniPromotionTask/listByCondition',
        add: '/uniPromotionTask/add',
        update: '/uniPromotionTask/update',
        delete: '/uniPromotionTask/delete',
        delete_batch: '/uniPromotionTask/deleteBatch',
        status: '/uniPromotionTask/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',  // 字段名
        label: 'agentId',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'name',  // 字段名
        label: '任务名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'type',  // 字段名
        label: '创建方式',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '立即创建 '
        }, {
          id: 2,
          name: '定时任务'
        }],
      }, {
        field: 'target',  // 字段名
        label: '营销目标',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '推商品  '
        }, {
          id: 2,
          name: '图文'
        }],
      }, {
        field: 'uniPromotionNum',  // 字段名
        label: '全域计划数',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'successNum',  // 字段名
        label: '创建成功',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'waitNum',  // 字段名
        label: '创建等待',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'failNum',  // 字段名
        label: '创建失败',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'productId',  // 字段名
        label: '商品ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
        detail: true,
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'name',  // 字段名
            label: 'name',  // 字段显示名称
            type: 'input',
            placeholder: '请输入name',
            rules: [
              { required: true, message: 'name不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'type',  // 字段名
            label: 'type',  // 字段显示名称
            type: 'input',
            placeholder: '请输入type',
            rules: [
              { required: true, message: 'type不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'target',  // 字段名
            label: 'target',  // 字段显示名称
            type: 'input',
            placeholder: '请输入target',
            rules: [
              { required: true, message: 'target不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'uniPromotionNum',  // 字段名
            label: 'uniPromotionNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入uniPromotionNum',
            rules: [
              { required: true, message: 'uniPromotionNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'successNum',  // 字段名
            label: 'successNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入successNum',
            rules: [
              { required: true, message: 'successNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'waitNum',  // 字段名
            label: 'waitNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入waitNum',
            rules: [
              { required: true, message: 'waitNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'failNum',  // 字段名
            label: 'failNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入failNum',
            rules: [
              { required: true, message: 'failNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped></style>
